import { generateTestId } from "@client-shared";

export const setWeeklyLimitPopoverTestId = (identifier: string): string => generateTestId("WeeklyLimitPopover", identifier);
